<template>
    <div class="page-filter">

        <div class="d-md-block">
            <a v-show="showLocationTrigger"
               href="#"
               class="font-size-small btn small mt-3 w-100"
               v-bind:class="{'disable-trigger': disableLocationTrigger, 'btn-transparent p-0 text-left': locationInSession, 'btn-primary': !locationInSession}"
               @click.prevent="triggerGetLocation(true, true)"
            >
                <span v-if="!showSpinner && !disableLocationTrigger">
                    <i class="fas fa-location-arrow mr-2"></i>
                    <span v-if="!text">Gebruik mijn locatie</span>
                    <span v-if="text">{{text}}</span>
                </span>
                <span v-if="showSpinner && !disableLocationTrigger">
                    <i class="fas fa-spinner fa-spin"></i>Nabije bioscopen zoeken...
                </span>

                <span v-if="disableLocationTrigger">
                    <i class="fas fa-location-arrow mr-2"></i>Zet uw locatievoorziening aan om bioscopen dichtbij te zoeken
                </span>
            </a>
        </div>
    </div>
</template>

<script>

    export default {
        props: {
            filterGroup: String,
            text: String,
            reloadOnRetrieval: String
        },
        data() {
            return {
                showLocationTrigger: true,
                showSpinner: false,
                disableLocationTrigger: false,
                nearbyCities: [],
                gettingCities: false,
                locationInSession: false
            };
        },
        mounted() {
            let pathName = window.location.pathname;

            // Listen for location trigger events
            VueEvents.$on('location:triggered', args => {
                let force = false;
                if(typeof args !== 'undefined' && args.force !== 'undefined') {
                    force = args.force;
                }

                this.triggerGetLocation(force);

            });

            VueEvents.$on('location-filter:get_cities', bool => {
                this.gettingCities = bool;
            });


            if(pathName === '/' && !window.location.search && MrMovie.geolocation.getLocationFromSession()) {

                let setParams = false;
                if(localStorage.getItem('cinema')) {
                    setParams = true;
                    MrMovie.pageFilter.addFilters('cinema', localStorage.getItem('cinema').split(","));
                }

                if(localStorage.getItem('city')) {
                    setParams = true;
                    MrMovie.pageFilter.addFilters('city', localStorage.getItem('city').split(","));
                }

                if(!MrMovie.pageFilter.getFilters()) {
                    this.getNearbyCities(MrMovie.geolocation.getLocationFromSession());
                } else if(true === setParams) {
                    setTimeout(function(){ MrMovie.pageFilter.updateQueryParams(); }, 1000);
                }



            }

            if(MrMovie.geolocation.getLocationFromSession()) {
                this.text = 'Ververs mijn locatie';
                this.locationInSession = true;
            }

        },
        methods: {
            /**
             * Set the nearby cities in the session
             * @return {void}
             */
            setSelectableCitiesInSession() {
                if (this.selectableItems.length) {
                    MrMovie.session.set({
                        selectable_cities: this.selectableItems,
                    }, 'Selectable cities');
                }
            },
            /**
             * Set the selected items in the session
             * @return {void}
             */
            setSelectedItemsInSession() {
                const selectedItemsFull = this.getSelectedItemsFull();

                if (selectedItemsFull.length) {
                    MrMovie.session.set({
                        selected_cities: selectedItemsFull,
                    }, 'Selected cities');
                }
            },


            setFilters() {
                for(let selectedItem in this.selected) {
                    if(this.selected[selectedItem]) {
                        this.cities.getValue(selectedItem).setSelected(true);
                    } else {
                        this.cities.getValue(selectedItem).setSelected(false);
                    }

                }

                MrMovie.locationFilter.setActiveFilters(this.cities);
                MrMovie.locationFilter.getActiveFilters().filter();
            },
            /**
             * Set the current cities by visitor location
             * @param {Event}
             * @return {void}
             */
            triggerGetLocation(force = false, manualTrigger = false) {
                if(!MrMovie.geolocation.loadingLocation()) {
                    this.showSpinner = true;
                }

                if(manualTrigger) {
                    VueEvents.$emit('location-filter:manual-triggered');
                }

                MrMovie.geolocation.getCurrentLocation(force)
                    .then(location => this.getNearbyCities(location))
                    .catch(reason => {
                        // Location is not available or refused
                        this.showSpinner = false;
                        this.showLocationTrigger = true;
                        if(typeof reason.code !== 'undefined' && reason.code === 1) {
                            VueEvents.$emit('location-filter:blocked', reason);
                            this.disableLocationTrigger = true;
                        }

                        $.post('/ajax/location/session', location);

                    }).always(reason => {
                       this.showSpinner = false;
                    })
            },

            getNearbyCities(location) {
                if(this.gettingCities) {
                    return;
                }

                VueEvents.$emit('location-filter:get_cities', true);
                return $.getJSON('/ajax/nearby-cities', location).then(response => {
                    this.showSpinner = false;

                    // Use emitting, because the mobile filter variant doesn't get the cities
                    // Because that call is cancelled (duplicate calls are prevented)
                    // This way, both normal and mobile filters get the city values
                    let cityValues = [];
                    for(let city of response.selectedCities) {
                        cityValues.push(city.slug);
                    }

                    let cinemaValues = [];
                    for(let cinema of response.selectedCinemas) {
                        cinemaValues.push(cinema.slug);
                    }

                    if(typeof response.cinemaDistances !== 'undefined') {
                        MrMovie.cinemaDistances.set(response.cinemaDistances);
                        VueEvents.$emit('location-filter:cinema_distances', response.cinemaDistances);
                    }


                    MrMovie.pageFilter.removeFilters('city');
                    MrMovie.pageFilter.removeFilters('cinema');
                    MrMovie.pageFilter.addFilters('city', cityValues);
                    MrMovie.pageFilter.addFilters('cinema', cinemaValues);
                    MrMovie.pageFilter.addFilters('cinema', cinemaValues);
                    MrMovie.pageFilter.addFilters('latitude', [location.latitude.toString()]);
                    MrMovie.pageFilter.addFilters('longitude', [location.longitude.toString()]);
                    MrMovie.pageFilter.updateQueryParams();
                    MrMovie.pageFilter.filter();

                    if(this.reloadOnRetrieval === 'true') {
                        window.location.reload();
                    } else {
                        MrMovie.pageFilter.removeFilters('latitude');
                        MrMovie.pageFilter.removeFilters('longitude');
                    }

                }).always(reason => {
                    VueEvents.$emit('location-filter:get_cities', false);
                });
            },
            /**
             * Format the cities objects for filter usage
             * @param cities
             * @return {Array}
             */
            formatCities(cities) {

                let filterItem = new FilterItem('city', 'Steden');

                cities.all.forEach((city) => {
                    filterItem.addValue(new FilterItemValue(city.slug, city.name))
                });

                cities.selected.forEach((city) => {
                    let selectedFilterItem = filterItem.getValue(city.slug);
                    if(selectedFilterItem) {
                        filterItem.setSelected(true);
                    }
                })

                return filterItem;
            },
            /**
             * Keep a copy of nearby cities, to optionally revert to later
             * @param cities
             * @return {Array}
             */
            keepNearbyCities(cities) {
                if (cities.all && cities.all.length) {
                    this.nearbyCities = cities.all;
                } else {
                    this.nearbyCities = [];
                }

                return cities;
            },
            /**
             * Set the city items to choose from
             * @return {void}
             */
            setSelectableCities(cities) {

                this.showSpinner = false;

                // Un-check all the checkboxes
                this.setCheckboxesState(false);

                // Set the items to choose from
                this.setSelectableItems(cities.getSelected() || []);
                this.setSelectableCitiesInSession();



                // Check the checkboxes of the nearest cities
                setTimeout(() => {

                    this.selected = {};
                    cities.getSelected().forEach(city => {
                        this.selected[city.getValue()] = true;
                    });

                    this.emitSelectedItems();

                    this.setSelectedItemsInSession();
                }, 50);
            },
            /**
             * Callback for the search change event
             * @return {void}
             */
            searchUpdated() {
                this.showSpinner = false;

                const searchLength = $.trim(this.searchCity).length;

                // Searching needs a minimum amount of characters
                // Only update, if the search value is different from the previous
                if (searchLength >= 3 && this.searchCity !== this.previousSearchCity) {
                    this.previousSearchCity = this.searchCity;

                    this.getCities(this.searchCity)
                        .then(this.setSelectableCities);
                }

                // Revert to the nearby cities
                else if (searchLength === 0) {
                    this.setSelectableCities({
                        all: this.nearbyCities,
                    });
                }
            },

            getCities(searchCity) {
                let queryParams = {};
                if(searchCity) {
                    queryParams = {s: searchCity};
                }
              return $.getJSON('/ajax/cities', queryParams)
                  .then(cities => {
                      return {
                          all: cities,
                          selected: [],
                      };
                  })
                  .then(this.formatCities);
            },
        },
    };
</script>



// WEBPACK FOOTER //
// resources/js/components/LocationFilter.vue